<template>
	<BaseCard :is-editable="isEditable" :title="$t('vehicle').toString()" :is-toggleable="false" @clickEdit="edit">
		<div v-if="vehicle">
			<BaseCardRow :value="licensePlate" :label="$t('license_plate')" />

			<BaseCardRow :value="vehicle.vehicleIdentificationNumber" :label="$t('vin')" />

			<BaseCardRow v-if="vehicle.manufacturer" :value="vehicle.manufacturer" :label="$t('manufacturer')" />

			<BaseCardRow v-if="vehicle.model" :value="vehicle.model" :label="$t('vehicle_model')" />
		</div>
		<div v-else class="font-bold">{{ $t('vehicle') }} {{ $t('not_stored') }}</div>
		<div v-if="vehicleRegistrationDocument" class="grid grid-cols-2 break-words leading-none mt-2 max-w-full w-full">
			<div class="font-bold flex items-center">{{ $t('vehicle_registration') }}:</div>

			<div class="flex items-center justify-between">
				<div>
					Hinterlegt
				</div>

				<button
					type="button"
					@click="openVehicleRegistrationDocument"
					:title="$t('accident_document').toString()"
					class="bg-sp btn block btn-overview-edit document-action-btn flex items-center justify-center text-white"
				>
					<font-awesome-icon :icon="['fas', 'file-alt']" />
				</button>
			</div>
		</div>
	</BaseCard>
</template>

<script>
import BaseCard from '@/components/damagecases/forms/BaseCard';
import BaseCardRow from '@/components/damagecases/forms/BaseCardRow';

export default {
	name: 'DamageAssessorCaseVehicleCard',

	components: {
		BaseCard,
		BaseCardRow,
	},
	props: {
		vehicle: {
			type: Object,
			default: null,
		},
		vehicleRegistrationDocument: {
			type: Object,
			default: null,
		},
		caseId: {
			type: [Number, String],
			required: true,
		},
		isEditable: {
			type: Boolean,
			default: true,
		},
	},
	computed: {
		licensePlate() {
			return this.vehicle?.licensePlate?.text ?? '-';
		},
	},
	methods: {
		edit() {
			this.$router.push({
				name: 'damageAssessorCaseEditVehicle',

				params: {
					id: this.caseId,
				},
			});
		},
		openVehicleRegistrationDocument() {
			this.$emit('openDocuments', 'customer');
		},
	},
};
</script>

<style scoped></style>
